import Vue from 'vue'  //引入vue
import vueRouter from 'vue-router'  //引入vue-router
const serviceAgreement = r => require.ensure([], () => r(require('@/pages/serviceAgreement')), 'service')
const androidPrivacy = r => require.ensure([], () => r(require('@/pages/androidPrivacy')), 'androidPrivacy')
const iosPrivacy = r => require.ensure([], () => r(require('@/pages/iosPrivacy')), 'iosPrivacy')
const infoGather = r => require.ensure([], () => r(require('@/pages/infoGather')), 'infoGather')
const catalog = r => require.ensure([], () => r(require('@/pages/catalog')), 'catalog')
const developer = r => require.ensure([], () => r(require('@/pages/developer')), 'developer')
const speedAndroidPrivacy = r => require.ensure([], () => r(require('@/pages/speed/androidPrivacy')), 'androidPrivacy')
const speedIosPrivacy = r => require.ensure([], () => r(require('@/pages/speed/iosPrivacy')), 'iosPrivacy')
const speedCatalog = r => require.ensure([], () => r(require('@/pages/speed/catalog')), 'catalog')
const speedInfoGather = r => require.ensure([], () => r(require('@/pages/speed/infoGather')), 'infoGather')
const speedServiceAgreement = r => require.ensure([], () => r(require('@/pages/speed/serviceAgreement')), 'serviceAgreement')

Vue.use(vueRouter)

function redirectToOfficialHome() {
  window.location.replace('../')
}

const rootRoute = process.env.NODE_ENV === 'production'
  ? { path: '/', beforeEnter: redirectToOfficialHome }
  : { path: '/', redirect: '/androidprivacy' }

export default new vueRouter({
  routes: [
    rootRoute,
    { path: '/service', name: 'service', component: serviceAgreement },
    { path: '/androidprivacy', name: 'androidPrivacy', component: androidPrivacy },
    { path: '/iosprivacy', name: 'iosrivacy', component: iosPrivacy },
    { path: '/infogather', name: 'infoGather', component: infoGather },
    { path: '/catalog', name: 'catalog', component: catalog },
    { path: '/developer', name: 'developer', component: developer }, // 开发者权限
    { path: '/speedAndroidPrivacy', name: 'androidPrivacy', component: speedAndroidPrivacy },
    { path: '/speedIosPrivacy', name: 'iosrivacy', component: speedIosPrivacy },
    { path: '/speedCatalog', name: 'androidPrivacy', component: speedCatalog },
    { path: '/speedInfoGather', name: 'iosrivacy', component: speedInfoGather },
    { path: '/speedServiceAgreement', name: 'iosrivacy', component: speedServiceAgreement }
  ]
})
